import React from 'react';
import { ProgressIndicator } from './ProgressIndicator';
import { ArrowLeft } from 'lucide-react';
interface SlideLayoutProps {
  children: React.ReactNode;
  footer?: string;
  progress?: {
    current: number;
    total: number;
  };
  onBack?: () => void;
}
export function SlideLayout({
  children,
  footer,
  progress,
  onBack
}: SlideLayoutProps) {
  return <div className="relative w-full h-full slide-background overflow-hidden flex flex-col" data-id="element-18">
      {/* Organic Wave Background Layers */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-19">
        <svg className="absolute w-full h-full" preserveAspectRatio="none" viewBox="0 0 1440 800" xmlns="http://www.w3.org/2000/svg" data-id="element-20">
          <path fill="#5B8FB5" fillOpacity="0.4" d="M0,320L48,336C96,352,192,384,288,384C384,384,480,352,576,325.3C672,299,768,277,864,288C960,299,1056,341,1152,346.7C1248,352,1344,320,1392,304L1440,288L1440,800L1392,800C1344,800,1248,800,1152,800C1056,800,960,800,864,800C768,800,672,800,576,800C480,800,384,800,288,800C192,800,96,800,48,800L0,800Z" data-id="element-21" />
          <path fill="#6B9FC5" fillOpacity="0.3" d="M0,400L48,416C96,432,192,464,288,453.3C384,443,480,389,576,378.7C672,368,768,400,864,426.7C960,453,1056,475,1152,464C1248,453,1344,411,1392,389.3L1440,368L1440,800L1392,800C1344,800,1248,800,1152,800C1056,800,960,800,864,800C768,800,672,800,576,800C480,800,384,800,288,800C192,800,96,800,48,800L0,800Z" data-id="element-22" />
        </svg>
      </div>

      {/* Navigation & Logos Layer */}
      <div className="absolute top-0 left-0 w-full p-8 z-20 flex justify-between items-start" data-id="element-23">
        <div className="flex flex-col gap-4" data-id="element-24">
          {/* Roche Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/5jhXUGPCcHgVPg96gzBpYf/Roche_Logo_800px_White_RGB_Roche_Logo_RGB.png" alt="Roche" className="h-12 w-auto opacity-90" data-id="element-25" />

          {/* Back Button */}
          {onBack && <button onClick={onBack} className="flex items-center gap-2 text-white hover:text-highlight transition-colors duration-200 font-bold text-lg mt-4" type="button" data-id="element-26">
              <ArrowLeft className="w-6 h-6" data-id="element-27" />
              BACK
            </button>}
        </div>

        <div className="flex items-center gap-8" data-id="element-28">
          {progress && <div className="bg-white/20 backdrop-blur-sm border border-white/30 text-white px-4 py-1.5 rounded-full text-sm font-bold" data-id="element-29">
              {progress.current}/{progress.total}
            </div>}
          {/* Vabysmo Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/kwT7adHpJchCEjPQy8hNic/vabysmo-logo.genecoreimg.750.png" alt="Vabysmo" className="h-12 w-auto drop-shadow-sm" data-id="element-30" />
        </div>
      </div>

      {/* Main Content Area */}
      <main className="relative z-10 flex-1 flex items-center justify-center px-12 py-6 overflow-hidden min-h-0" data-id="element-31">
        <div className="w-full h-full flex items-center justify-center" data-id="element-32">
          {children}
        </div>
      </main>

      {/* Footer Text */}
      <div className="absolute bottom-4 right-8 z-20 text-right" data-id="element-33">
        {footer && <p className="text-[10px] text-white font-medium opacity-80" data-id="element-34">
            {footer}
          </p>}
      </div>
    </div>;
}